import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'makaw-card-button',
  templateUrl: './card-button.component.html',
  styleUrls: ['./card-button.component.scss'],
})
export class CardButtonComponent implements OnInit {
  @Input() gradient;
  @Input() icon;
  @Input() icon2;
  @Input() text;

  constructor() {}

  get classes() {
    const cssClasses = {};

    if (this.gradient) cssClasses[this.gradient] = true;

    return cssClasses;
  }
  ngOnInit() {}
}
